/* eslint-disable react/jsx-no-constructed-context-values */
import React, { createContext } from "react";
import useDarkMode, { getInitialTheme, setThemeHeader } from "./useDarkMode";

export const ThemeContext = createContext(getInitialTheme);

/* istanbul ignore next */
export function ThemeProvider({ children }) {
  const [colorTheme, changeTheme] = useDarkMode();

  const setTheme = (val) => {
    changeTheme((prev) => {
      setThemeHeader(val, prev);
      return val;
    });
  };

  return (
    <ThemeContext.Provider value={{ colorTheme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export default ThemeProvider;
